// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"230":"component---src-pages-index-jsx","256":"component---src-pages-404-jsx","532":"styles"}[chunkId] + "-" + {"230":"cf1b870fda3cbc99fcb3","256":"6e0769bdf2cccf23227e","532":"9a44b0c96edc28263ac1"}[chunkId] + ".js";
};